import React from 'react'
import * as Sentry from "@sentry/react"

function ErrorFallback(_props) {
  return <div>An error occurred.</div>
}

export function ErrorBoundary(props)  {
  const beforeCapture = (scope, _error, _componentStack) => {
    scope.setExtras({ inErrorBoundary: true })
  }

  return <Sentry.ErrorBoundary fallback={ErrorFallback} beforeCapture={beforeCapture}>
    {props.children}
  </Sentry.ErrorBoundary>
}
